export default "__VITE_ASSET__DvUJvxoI__"